import { render, staticRenderFns } from "./Huoyue1.vue?vue&type=template&id=31a667a3&scoped=true"
import script from "./Huoyue1.vue?vue&type=script&lang=js"
export * from "./Huoyue1.vue?vue&type=script&lang=js"
import style0 from "./Huoyue1.vue?vue&type=style&index=0&id=31a667a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a667a3",
  null
  
)

export default component.exports